import { useCallback, useEffect, useRef, useState } from 'react';

// ─────────────────────────────────────────────────────────────────────────────

export const useCustomizationStepperTimeout = () => {
  //
  // ─── State ───────────────────────────────────────────────────────────

  const [activeStepperId, setActiveStepperId] = useState<string | null>(null);

  // ─── Refs ────────────────────────────────────────────────────────────

  const timeout = useRef<ReturnType<typeof setTimeout>>(undefined);

  // ─── Helpers ─────────────────────────────────────────────────────────

  const clearStepperTimeout = useCallback(() => {
    if (!timeout.current) return;

    clearTimeout(timeout.current);
  }, []);

  const resetStepperTimeout = useCallback(() => {
    clearStepperTimeout();

    timeout.current = setTimeout(() => {
      setActiveStepperId(null);
    }, STEPPER_TIMEOUT);
  }, [clearStepperTimeout]);

  // ─── Effects ─────────────────────────────────────────────────────────

  useEffect(() => clearStepperTimeout, [clearStepperTimeout]);

  // ─────────────────────────────────────────────────────────────────────

  return {
    activeStepperId,
    setActiveStepperId,
    resetStepperTimeout,
    clearStepperTimeout,
  };
};

// ─── Constants ───────────────────────────────────────────────────────────────

const STEPPER_TIMEOUT = 1200;
